import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { BsEye, BsDownload } from "react-icons/bs";
import AxisSpinner from "../components/AxisSpinner";

const ViewPdfModal = ({
  visible,
  close,
  pdfUrl,
  title,
  onDownload,
  loading = false
}) => {
  return (
    <Modal 
      show={visible} 
      onHide={close}
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-capitalize">
          <h1 className="text-axis-offblack icon-text-wrapper">
            <BsEye className="icon-right-spacing" />
            {title}
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        {loading ? (
          <div className="text-center py-5">
            <AxisSpinner loading={loading} />
          </div>
        ) : (
          <div style={{ height: "80vh" }}>
            <iframe
              height="100%"
              width="100%"
              title={title}
              src={pdfUrl}
              type="application/pdf"
              style={{ border: "none" }}
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="d-flex gap-2">
        <Button
          variant="primary"
          onClick={onDownload}
          disabled={!pdfUrl}
          className="flex-fill"
        >
          <BsDownload className="me-2" />
          Download PDF
        </Button>
        <Button
          variant="secondary"
          onClick={close}
          className="flex-fill"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewPdfModal;